export const tipoAlteracaoEnum = {
  PRORROGACAO: 1,
  INTERRUPCAO: 2,
  ADIAMENTO: 3,
  ANTECIPACAO: 4,
};

export const tipoReprogramacaoEnum = {
  NORMAL: 1,
  MATERNIDADE_PATERNIDADE: 2,
  LICENCA_MEDICA: 3,
};

export const tipoPerfil = {
  ADMINISTRADOR_SISTEMA: 1,
  SOLICITANTE: 2,
  CHEFE_DIRETO: 3,
  COMANDANTE_COMPANHIA: 4,
  CHEFE_SEPLAN: 5,
  COMANDANTE: 6,
  GERENCIA: 7,
  UNIDADE_APOIADORA: 8,
  SEPLAN_ENSINO: 9,
  TEST_UNI: 82,
};

export const TIPO_ALTERACAO = [
  {
    value: 1,
    text: "Prorrogação",
  },
  {
    value: 2,
    text: "Interrupção",
  },
  {
    value: 3,
    text: "Adiamento",
  },
  {
    value: 4,
    text: "Antecipação",
  },
];

export const TIPOS_CIVIS = [
  {
    value: 1,
    text: "Amplo",
  },
  {
    value: 2,
    text: "Limitado",
  },
];

export const TIPO_ALTERACAO_PRORROGACAO = [
  {
    value: "Luto",
    text: "Luto",
  },
  {
    value: "Núpcias",
    text: "Núpcias",
  },
  {
    value: "Adoção Paterna",
    text: "Adoção Paterna",
  },
  {
    value: "Paternidade",
    text: "Paternidade",
  },
];

export const TIPO_ALTERACAO_INTERRUPCAO = [
  {
    value: "Maternidade",
    text: "Maternidade",
  },
  {
    value: "Adoção Materna",
    text: "Adoção Materna",
  },
];

export const AJUSTAR_FERIAS_TIPO_ALTERACAO = [
  {
    value: 1,
    text: "Adiamento",
  },
  {
    value: 2,
    text: "Antecipação",
  },
];

export const TIPO_DE_FERIAS = [
  {
    value: 4,
    text: "Férias prêmio",
  },
  {
    value: 1,
    text: "Férias Anuais",
  },
];

export const TiposFeriasEnum = {
  FERIAS_ANUAL: 1,
  FERIAS_30_ANOS:2,
  FERIAS_ESCOLAR:3,
  FERIAS_PREMIO: 4,
};

export const ServidorCivil = [
  {
    value: null,
    text: "Selecione",
  },
  {
    value: 1,
    text: "Amplo",
  },
  {
    value: 2,
    text: "Limitado",
  },
];

export const FUNCIONALIDADES = {
  CALEANDARIO_FERIAS: 1,
  HISTORICO_FERIAS: 2,
  HISTORICO_ANUAL: 3,
  HISTORICO_FERIAS_PREMIO: 4,
  GERENCIAR_USUARIOS: 5,
  FERIAS_ESCOLARES: 6,
  CALENDARIO_FERIAS_ESCOLARS: 7,
  DISCENTE_FERIAS: 8,
  MEUS_DADOS: 9,
  PARAMETRIZAR_CALENADRIO: 10,
  ATRIBUIR_FERIADOS: 11,
  APROVAR_FERIAS_PARA_VANTAGEM: 12,
  EXCLUIR_FERIAS: 13,
  ATOS_E_BOLETIM: 14,
  EMITIR_RELATORIO: 15,
  ACESSAR_MAPEAMENTO_FERIAS: 16,
  FERIAS_PRORROGADAS_INTERROMPIDAS: 17,
  AGENDAR_FERIAS: 18,
  CONFIGURACAO: 37,
  MAPEAMENTO_FERIAS: 18,
  COMPARATIVO: 39,
}
